import { useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import DataTable from 'components/Common/DataTable';
import { ColumnDef } from '@tanstack/react-table';
import { MdOutlineEdit } from 'react-icons/md';
import { RiDeleteBin6Line } from 'react-icons/ri';
import Button from '@/components/Common/Button';
import AddOffDayDrawer from './AddOffDayDrawer';
import { useFieldArray } from 'react-hook-form';

export type HolidayForm = {
  date: string;
  reason: string;
};

export default function OffDays({ control, fieldName = 'team_member.holidays' }: { control: any; fieldName?: string }) {
  const { fields, append, update, remove } = useFieldArray({
    control,
    name: fieldName
  });

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [editIndex, setEditIndex] = useState<number | null>(null);

  const handleAdd = () => {
    setEditIndex(null);
    setDrawerOpen(true);
  };

  const handleEdit = (index: number) => {
    setEditIndex(index);
    setDrawerOpen(true);
  };

  const handleDelete = (index: number) => {
    remove(index);
  };

  return (
    <Box mt={4}>
      <Box textAlign='end' mb={2}>
        <Button onClick={handleAdd}>Add</Button>
      </Box>

      <DataTable data={fields} columns={columns(handleEdit, handleDelete)} isHeaderSticky={false} />

      <AddOffDayDrawer
        open={drawerOpen}
        handleClose={() => setDrawerOpen(false)}
        editIndex={editIndex}
        append={append}
        update={update}
        holidays={fields as any}
      />
    </Box>
  );
}

const columns = (handleEdit: (index: number) => void, handleDelete: (index: number) => void): ColumnDef<any>[] => [
  {
    header: 'Date',
    accessorKey: 'date',
    cell: (info) => <Typography>{info.getValue() as string}</Typography>
  },
  {
    header: 'Reason',
    accessorKey: 'reason',
    cell: (info) => <Typography>{info.getValue() as string}</Typography>
  },
  {
    header: 'Action',
    cell: ({ row }) => (
      <Box display='flex' gap={1}>
        <IconButton onClick={() => handleEdit(row.index)}>
          <MdOutlineEdit />
        </IconButton>
        <IconButton color='error' onClick={() => handleDelete(row.index)}>
          <RiDeleteBin6Line />
        </IconButton>
      </Box>
    )
  }
];
